export default "__VITE_ASSET__Bgoh4mer__"